// extracted by mini-css-extract-plugin
module.exports = {"significanceContainer":"SignificanceContainer_significanceContainer__3Mype","title":"SignificanceContainer_title__3Ef86","signPercent":"SignificanceContainer_signPercent__2z77A"};